import React, { ReactElement, useState } from 'react';
import {
  Breadcrumbs,
  HiddenPriorityTitle,
  homeBreadcrumb,
  Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import PouzivatelskePrirucky from '../../module/PouzivatelskePrirucky';
import { getPouzivatelskePrirucky } from '../../client/pouzivatelskePriruckyClient';

const PriruckyPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getPouzivatelskePrirucky(),
  );
  const [displayError, setDisplayError] = useState(true);

  return (
    <Layout>
      <HiddenPriorityTitle>Používateľské príručky</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.prirucky.to,
            heading: routes.prirucky.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399) ? (
          <>
            {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať používateľské príručky.
              </Message>
            )}
          </>
        )
          : (
            <PouzivatelskePrirucky
              data={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default PriruckyPage;
